import { combineReducers } from '@reduxjs/toolkit'
import { activityMonitorReducer } from './activityMonitor'
import { connectionReducer } from './connection'
import { configurationReducer } from './configuration'
import { gridReducer } from './grid'
import { notificationReducer } from './notification'
import { selectionReducer } from './selection'
import { repositoryReducer } from './repository/repositoryReducer'
import { timeReducer } from './time'
import { systemReducer } from './system'
import { negotiationRepositoryReducer } from './repository/negotiationRepositoryReducer'
import { spreadsheetUploadReducer } from './spreadsheetUpload/spreadsheetUploadReducer'

export const globalReducer = combineReducers({
  activityMonitorStore: activityMonitorReducer,
  connectionStore: connectionReducer,
  configurationStore: configurationReducer,
  gridStore: gridReducer,
  notificationStore: notificationReducer,
  repositoryStore: repositoryReducer,
  negotiationRepositoryStore: negotiationRepositoryReducer,
  selectionStore: selectionReducer,
  spreadsheetUploadStore: spreadsheetUploadReducer,
  timeStore: timeReducer,
  systemStore: systemReducer
})

export interface GlobalState extends ReturnType<typeof globalReducer> {}
